import type { QueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";

export const invalidateDocumentListsWhenIdle = (queryClient: QueryClient) => {
	if (queryClient.isMutating({ mutationKey: DocumentKeys.mutation }) > 1) {
		return;
	}
	queryClient.invalidateQueries({ queryKey: DocumentKeys.allLists });
};
